import { useRef, useState, useEffect } from "react";

import { getRandomId } from "../../utils/utils";
import {
  getDefaultFormFromTemplate,
  getEmptyFieldsErrorFromTemplate,
} from "../../utils/form";
import { adminEndpoints } from "../../api/endpoints";

const cardinalDirections = [
  { label: "Nord", value: "N" },
  { label: "Nord-Ost", value: "NE" },
  { label: "Ost", value: "E" },
  { label: "Süd-Ost", value: "SE" },
  { label: "Süd", value: "S" },
  { label: "Süd-West", value: "SW" },
  { label: "West", value: "W" },
  { label: "Nord-West", value: "NW" },
];

const getClientConfigureFormTemplate = (
  location,
  hasPv = false,
  disabled = false,
  getInverterTable = null,
  getWallboxTable = null,
  getRelayTable = null,
  getEMeterTable = null,
  getHeatpumpTable = null,
) => {
  const roofTemplate = [
    {
      type: "dropdown",
      name: "Himmelsrichtung",
      key: "direction",
      options: cardinalDirections,
      separator: false,
      default: null,
    },
    {
      type: "input_number",
      key: "kwp",
      name: "kWp",
      separator: false,
      props: { style: { width: 200 } },
      default: null,
    },
    {
      type: "checkbox",
      key: "is_flat",
      name: "Flachdach",
      separator: false,
      default: false,
    },
    {
      type: "input_number",
      key: "location",
      name: "Standort",
      default: location?.id || "",
      hide: true,
    },
  ];

  return [
    {
      type: "input_chars",
      key: "serial",
      name: "Geräte-ID",
      width: "50%",
      disabled: true,
      default: null,
    },
    {
      type: "input_chars",
      disabled: true,
      width: "50%",
      name: "Standort",
      value: location?.name || "",
    },
    {
      type: "input_chars",
      disabled: true,
      width: "50%",
      name: "Adresse",
      value: location?.address || "",
    },
    {
      type: "formlist",
      name: "Dächer",
      key: "roof_set",
      template: roofTemplate,
      addBtnName: "Dach hinzufügen",
      disabled,
      condition: (form) => hasPv,
      default: [],
      empty: [],
    },
    {
      type: "input_number",
      key: "location",
      name: "Standort",
      default: location?.id || "",
      hide: true,
    },
    {
      type: "custom",
      key: "impulsinverter_set",
      default: [],
      empty: [],
      optional: true,
      hide: (form) => !(form?.impulsinverter_set?.length > 0),
      getFieldHtml: (form) => {
        return (
          form?.impulsinverter_set?.length > 0 &&
          getInverterTable &&
          getInverterTable(form)
        );
      },
    },
    {
      type: "custom",
      key: "impulswallbox_set",
      default: [],
      empty: [],
      optional: true,
      hide: (form) => !(form?.impulswallbox_set?.length > 0),
      getFieldHtml: (form) => {
        return (
          form?.impulswallbox_set?.length > 0 &&
          getWallboxTable &&
          getWallboxTable(form)
        );
      },
    },
    {
      type: "custom",
      key: "impulsrelay_set",
      default: [],
      empty: [],
      optional: true,
      hide: (form) => !(form?.impulsrelay_set?.length > 0),
      getFieldHtml: (form, setForm) => {
        const checkRelayHeatpump = (relay, checked) => {
          const heatpump = form.impulsheatpump_set.find(
            (h) => h.relay === relay.id,
          );
          setForm((f) => {
            f = { ...f };
            if (checked) {
              if (!heatpump)
                f.impulsheatpump_set.push({
                  id: -getRandomId(),
                  impuls: relay.impuls,
                  name: `Wärmepumpe ${relay.identifier}`,
                  identifier: relay.identifier,
                  location: relay.location,
                  relay: relay.id,
                  resourcetype: "ImpulsHeatpump",
                });
            } else
              f.impulsheatpump_set = f.impulsheatpump_set.filter(
                (h) => h.relay !== relay.id,
              );
            return f;
          });
        };
        return (
          form?.impulsrelay_set?.length > 0 &&
          getRelayTable &&
          getRelayTable(form, checkRelayHeatpump)
        );
      },
    },
    {
      type: "custom",
      key: "impulsemeter_set",
      default: [],
      optional: true,
      hide: (form) => !(form?.impulsemeter_set?.length > 0),
      getFieldHtml: (form, setForm) => {
        const wallboxDeviceList = form?.impulswallbox_set
          ? form.impulswallbox_set.map((w) => ({
              label: w.name,
              value: w.id,
              emeter: w.emeter,
            }))
          : [];
        const heatpumpDeviceList = form?.impulsheatpump_set
          ? form.impulsheatpump_set.map((hp) => ({
              label: hp.name,
              value: hp.id,
              emeter: hp.emeter,
            }))
          : [];
        const deviceList = [...wallboxDeviceList, ...heatpumpDeviceList];
        const assignEMeter = (emeter, value) => {
          setForm((f) => {
            f = { ...f };
            const wallboxes = f.impulswallbox_set;
            wallboxes.forEach((w) => {
              if (w.emeter === emeter.id) w.emeter = null;
            });
            const chosenWallbox = wallboxes.find((w) => w.id === value);
            if (chosenWallbox) chosenWallbox.emeter = emeter.id;
            const heatpumps = f.impulsheatpump_set;
            heatpumps.forEach((hp) => {
              if (hp.emeter === emeter.id) hp.emeter = null;
            });
            const chosenHeatpump = heatpumps.find((hp) => hp.id === value);
            if (chosenHeatpump) chosenHeatpump.emeter = emeter.id;
            return f;
          });
        };
        return (
          form?.impulsemeter_set?.length > 0 &&
          getEMeterTable &&
          getEMeterTable(form, deviceList, assignEMeter)
        );
      },
    },

    {
      type: "custom",
      key: "impulsheatpump_set",
      default: [],
      optional: true,
      hide: (form) => !(form?.impulsheatpump_set?.length > 0),
      getFieldHtml: (form) => {
        return (
          form?.impulsheatpump_set?.length > 0 &&
          getHeatpumpTable &&
          getHeatpumpTable(form)
        );
      },
    },
  ];
};

const defaultClientConfigureForm = getDefaultFormFromTemplate(
  getClientConfigureFormTemplate(null),
);

export default function useClientConfiguration(
  client,
  resetParent,
  apiClient,
  showMsg,
  getInverterTable,
  getEMeterTable,
  getRelayTable,
  getWallboxTable,
  getHeatpumpTable,
  updateInterval = 5000,
  isFocused = true,
) {
  const [clientForm, setClientForm] = useState({
    ...defaultClientConfigureForm,
  });
  const [showMissingFields, setShowMissingFields] = useState(false);

  const initialized = useRef(false);
  const interval = useRef(null);

  const hasPv =
    clientForm?.impulsinverter_set && clientForm.impulsinverter_set.length > 0;

  const clearData = () => {
    setClientForm({
      ...defaultClientConfigureForm,
      ...(client || {}),
    });
    setShowMissingFields(false);
    initialized.current = false;
  };

  const loadData = async () => {
    setClientForm({
      ...defaultClientConfigureForm,
      ...(client || {}),
    });
    await Promise.all([loadCient(), loadRoofs()]);
  };

  const initData = async () => {
    await loadData();
    initialized.current = true;
  };

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  const startRecurrentUpdate = (intervalTime) => {
    if (!interval.current)
      interval.current = setInterval(() => updateData(), intervalTime);
  };

  const stopRecurrentUpdate = () => {
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }
  };

  useEffect(() => {
    if (initialized.current && updateInterval) {
      startRecurrentUpdate(updateInterval);
      return stopRecurrentUpdate; // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }
    if (!initialized.current) stopRecurrentUpdate();
  }, [initialized.current]);

  const loadCient = async () => {
    const response = await apiClient.get(adminEndpoints.client + client.id, {
      nested: true,
    });
    setClientForm((d) => ({ ...d, ...response.data }));
  };

  const loadRoofs = async () => {
    const response = await apiClient.get(adminEndpoints.roof, {
      location: client.location,
    });
    setClientForm((d) => ({ ...d, roof_set: response.data }));
  };

  const updateData = async () => {
    const response = await apiClient.get(adminEndpoints.client + client.id, {
      nested: true,
    });
    const newClientForm = response.data;

    setClientForm((c) => {
      let updated = false;
      const keys = [
        "impulsemeter_set",
        "impulswallbox_set",
        "impulsinverter_set",
        "impulsrelay_set",
      ];
      const prevRelayIds = c.impulsrelay_set.map((r) => r.id);
      keys.forEach((key) => {
        const prevN = c[key].length;
        // exclude devices that are not there anymore
        const newIds = newClientForm[key].map((x) => x.id);
        c[key] = c[key].filter((x) => newIds.includes(x.id));
        updated = updated || c[key].length !== prevN;
        // add new devices
        const ids = c[key].map((x) => x.id);
        const additional = newClientForm[key].filter(
          (x) => !ids.includes(x.id),
        );
        c[key].push(...additional);
        updated = updated || additional.length > 0;
      });
      const prevNHeatpumps = c.impulsheatpump_set.length;
      // remove heatpumps where the relay is missing
      c.impulsheatpump_set = c.impulsheatpump_set.filter(
        (h) => !!c.impulsrelay_set.find((r) => h.relay === r.id),
      );
      updated = updated || c.impulsheatpump_set.length !== prevNHeatpumps;
      // add new heatpumps
      const hpRelayIds = c.impulsheatpump_set.map((h) => h.relay);
      const additional = newClientForm.impulsheatpump_set.filter(
        (h) =>
          !prevRelayIds.includes(h.relay) && // only add heatpumps of new relays (else it is added again even if changed in the frontend)
          !hpRelayIds.includes(h.relay) && // not already added
          c.impulsrelay_set.find((r) => h.relay === r.id), // related relays exists
      );
      c.impulsheatpump_set.push(...additional);
      updated = updated || additional.length > 0;

      // update configuration_locked
      if (newClientForm.configuration_locked !== c.configuration_locked) {
        c.configuration_locked = newClientForm.configuration_locked;
        updated = true;
      }
      return updated ? { ...c } : c;
    });
  };

  const submit = async (form) => {
    await apiClient.post(
      adminEndpoints.configureclient,
      {
        impulsinverter_set: form.impulsinverter_set,
        impulswallbox_set: form.impulswallbox_set,
        impulsheatpump_set: form.impulsheatpump_set,
        impulsemeter_set: form.impulsemeter_set,
        impulsrelay_set: form.impulsrelay_set,
      },
      { client_id: client.id },
    );
    if (hasPv) {
      await apiClient.put(adminEndpoints.roof, form.roof_set, {
        location: form.location,
      });
    }
  };

  const buffer = async (form) => {
    if (hasPv) {
      await apiClient.put(adminEndpoints.roof, form.roof_set, {
        location: form.location,
      });
    }
  };

  const _onSubmit = async (
    onSuccess,
    successMsg = "Änderungen gespeichert.",
    errorMsg = "Änderungen konnten nicht gespeichert werden.",
    submitFunc = submit,
  ) => {
    const emptyFieldsError = getEmptyFieldsErrorFromTemplate(
      template,
      clientForm,
    );
    if (emptyFieldsError) {
      setShowMissingFields(true);
      showMsg?.("Bitte alle Informationen eintragen!", "warning");
      console.warn(emptyFieldsError);
      return;
    }

    setShowMissingFields(false);

    try {
      await submitFunc(clientForm);
      const msg = successMsg;
      showMsg?.(msg);
      resetParent?.();
      onSuccess?.();
    } catch (error) {
      console.warn('Error in "client:onSubmit"', error, error.stack);
      showMsg?.(errorMsg, "error");
    }
  };

  const onSubmit = async (onSuccess) => {
    if (clientForm.configuration_locked) {
      showMsg?.(
        "Gerät ist nicht erreichbar, bitte in 1 Minute erneut versuchen!",
        "error",
      );
      return;
    }
    return _onSubmit(
      onSuccess,
      client.configured
        ? "Änderungen gespeichert!"
        : "Das Gerät wurde erfolgreich konfiguriert!",
      client.configured
        ? "Änderungen konnten nicht gespeichert werden."
        : "Das Gerät konnte nicht konfiguriert werden.",
    );
  };

  const onBuffer = async (onSuccess) => {
    return _onSubmit(
      onSuccess,
      "Änderungen gespeichert.",
      "Änderungen konnten nicht gespeichert werden.",
      buffer,
    );
  };

  const onUnassign = async (onSuccess) => {
    setShowMissingFields(false);
    try {
      await apiClient.put(adminEndpoints.client + client.id, {
        location: null,
      });
      const msg = "Der Standort wurde erfolgreich entfernt.";
      showMsg?.(msg);
      resetParent?.();
      onSuccess?.();
    } catch (error) {
      console.warn('Error in "client:onUnassign"', error, error.stack);
      showMsg?.("Der Standort konnte nicht entfernt werden", "error");
    }
  };

  const onReset = async (onSuccess) => {
    setShowMissingFields(false);

    try {
      await apiClient.put(adminEndpoints.client + client.id, {
        configured: false,
        configuration_locked: true,
      });
      const msg = "Das Gerät wurde erfolgreich zurückgesetzt.";
      showMsg?.(msg);
      resetParent?.();
      onSuccess?.();
    } catch (error) {
      console.warn('Error in "client:onReset"', error, error.stack);
      showMsg?.("Das Gerät konnte nicht zurückgesetzt werden", "error");
    }
  };

  // console.log(clientForm)

  const template = getClientConfigureFormTemplate(
    clientForm?._location,
    hasPv,
    clientForm.configured,
    getInverterTable,
    getWallboxTable,
    getRelayTable,
    getEMeterTable,
    getHeatpumpTable,
  );

  return {
    form: {
      form: clientForm,
      setForm: setClientForm,
      template,
      showMissingFields,
    },
    data: { update: loadData, clear: clearData, init: initData },
    recurrentUpdate: { start: startRecurrentUpdate, stop: stopRecurrentUpdate },
    onReset,
    onBuffer,
    onUnassign,
    onSubmit,
  };
}
